import React from 'react';
import logoImage from '../../assets/img/logo.png';

function Logo(
    imageMode = false,
) {
    return (
        imageMode
            ?
            <img src={logoImage} alt='Logo' className="me-2" width={120}/>
            :
            <div className="logo-checkin mb-3 text-center">
                <span>Check</span> <span className="highlight">in</span>
            </div >
    );
}
export default Logo;